import { render, staticRenderFns } from "./NotRegistered.vue?vue&type=template&id=6b0767d8&"
import script from "./NotRegistered.vue?vue&type=script&lang=js&"
export * from "./NotRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0767d8')) {
      api.createRecord('6b0767d8', component.options)
    } else {
      api.reload('6b0767d8', component.options)
    }
    module.hot.accept("./NotRegistered.vue?vue&type=template&id=6b0767d8&", function () {
      api.rerender('6b0767d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/NotRegistered.vue"
export default component.exports